import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class MinusIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="10" viewBox="0 0 10 10" width="10" xmlns="http://www.w3.org/2000/svg"><path stroke="null" d="M6 3.947h4v2H0v-2h6z"/></svg>
        )
    }
}

export default withCssClassName(MinusIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/minus-icon.js